import { render, staticRenderFns } from "./DashboardLogs.vue?vue&type=template&id=4b2d9196&scoped=true&"
import script from "./DashboardLogs.vue?vue&type=script&lang=ts&"
export * from "./DashboardLogs.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardLogs.vue?vue&type=style&index=0&id=4b2d9196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d9196",
  null
  
)

export default component.exports